var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureTileIcon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#ACADFF",
    strokeLinecap: "square",
    cx: 32,
    cy: 32,
    rx: 5.5,
    ry: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 21v22M21 32h22",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeLinecap: "square",
    cx: 32,
    cy: 32,
    r: 11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon03);
export default __webpack_public_path__ + "static/media/feature-tile-icon-03.69e94e20efba0832770920ab1d93d073.svg";
export { ForwardRef as ReactComponent };